export type ConversionEvent =
  | "sourcing_request_click"
  | "whatsapp_click"
  | "sourcing_form_start"
  | "sourcing_form_submit"
  | "freight_quote_form_start"
  | "freight_quote_add_carton"
  | "freight_quote_submit"
  | "freight_quote_success";
type AnalyticsWindow = Window & {
  gtag?: (command: string, event: string, params: Record<string, string>) => void;
  dataLayer?: unknown[];
};

/** Uses the site's existing tag, or queues events for a deployment-managed GTM tag.
 * No form answers, contact details, query strings or referrers are transmitted.
 */
export function trackConversion(event: ConversionEvent, location: string) {
  if (typeof window === "undefined") return;
  const target = window as AnalyticsWindow;
  const params = { page_path: window.location.pathname, cta_location: location };
  try {
    if (typeof target.gtag === "function") target.gtag("event", event, params);
    else (target.dataLayer ??= []).push({ event, ...params });
  } catch {
    // Analytics must never interrupt navigation or successful form submission.
  }
}
